import { render } from "./GoalCard.vue?vue&type=template&id=a13fcba0"
import script from "./GoalCard.vue?vue&type=script&lang=js"
export * from "./GoalCard.vue?vue&type=script&lang=js"
script.render = render

export default script